import { GetServerSidePropsContext } from "next";

import Home from "views/index";
import { GetFrontModulesResp } from "services/page/app";
import { parseProductTagFromUrl } from "utils/playground/url";
import { IncomingMessage } from "http";
import { reconstructFrontMods } from "serverutils/initProductInfo";
import { CommonRuntime, getMeta } from "utils/runtime";
import { isNotBlankArray } from "utils/array";
import e from "utils/catchAsyncError";
import {
    fetchServerGetFrontModules,
    fetchServerGetFrontPlayground,
    fetchServerGetSeoInfo,
} from "utils/serverFetch";

type IncomingMessagePro = IncomingMessage & {
    cookies: { [key: string]: string };
    runtime?: CommonRuntime;
};
interface GetServerSidePropsContextPro extends GetServerSidePropsContext {
    req: IncomingMessagePro;
}

export const getServerSideProps = async ({
    req,
    query,
}: GetServerSidePropsContextPro) => {
    const runtime = req.runtime;
    const { id, version } = runtime;
    const meta = getMeta(runtime);

    const tag: string = (query.tag as string) || "";
    const [, seoInfo] = await e(fetchServerGetSeoInfo)({ pageId: id }, { runtime });
    const [, playgroundData] = await e(fetchServerGetFrontPlayground)(
        {
            id,
            meta,
            version,
        },
        { runtime }
    );
    const tagQuery = parseProductTagFromUrl(tag || "");
    let frontMods = {};
    if (isNotBlankArray(playgroundData?.modules)) {
        const moduleId: string[] = [
            ...playgroundData.modules
                .filter((item) => item.header?.position)
                .map((item) => item.id),
        ];
        const modRes: GetFrontModulesResp = await fetchServerGetFrontModules(
            {
                moduleId,
                meta,
            },
            {
                runtime,
            }
        );
        frontMods = modRes?.mods
            ? await reconstructFrontMods({
                  mods: modRes.mods,
                  meta,
                  tagQuery,
                  runtime: req.runtime,
              })
            : {};
    }
    return {
        props: {
            modules: playgroundData?.modules || [],
            page: playgroundData?.page || null,
            frontModules: frontMods ? Object.values(frontMods) : [],
            runtime,
            tagQuery,
            title: seoInfo?.pageName || playgroundData?.page?.name || "",
        },
    };
};

export default Home;
